export function calculate(dataCalculate) {
    return axios({
        url: '/api/' + process.env.VUE_APP_SERVER_MODE + '/insurance/calculator/osago',
        method: 'GET',
        params: dataCalculate,
    });
}
